import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Services from './components/Services';
import Philosophy from './components/Philosophy';
import SuccessStories from './components/SuccessStories';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollSpy from './components/ScrollSpy';
import BackToTop from './components/BackToTop';
import LanguageSelector from './components/LanguageSelector';
import { LanguageProvider, useLanguage } from './context/LanguageContext';

const AppContent: React.FC = () => {
  const { t } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('home');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <ScrollSpy>
      <div className="App">
        <nav className="nav">
          <a href="#home" className="logo" onClick={handleLogoClick}>NutriFit Consulting</a>
          <div className="nav-links">
            <a href="#services">{t('nav.services')}</a>
            <a href="#philosophy">{t('nav.philosophy')}</a>
            <a href="#success-stories">{t('nav.successStories')}</a>
            <a href="#about">{t('nav.about')}</a>
            <a href="#contact">{t('nav.contact')}</a>
            <LanguageSelector />
          </div>
          <button 
            className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </nav>
        <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`} onClick={() => setIsMobileMenuOpen(false)}></div>
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <a href="#services" onClick={() => setIsMobileMenuOpen(false)}>{t('nav.services')}</a>
          <a href="#philosophy" onClick={() => setIsMobileMenuOpen(false)}>{t('nav.philosophy')}</a>
          <a href="#success-stories" onClick={() => setIsMobileMenuOpen(false)}>{t('nav.successStories')}</a>
          <a href="#about" onClick={() => setIsMobileMenuOpen(false)}>{t('nav.about')}</a>
          <a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>{t('nav.contact')}</a>
          <div className="mobile-menu-language">
            <LanguageSelector />
          </div>
        </div>
        <Header />
        <Services />
        <Philosophy />
        <SuccessStories />
        <About />
        <Contact />
        <Footer />
        <BackToTop />
      </div>
    </ScrollSpy>
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};

export default App;
